module.exports = "/fonts/nucleo.woff2?5987dd12fea78ce5f97ae601b08ec03c";